import { Outlet } from "react-router-dom"
import Header from "../Header"
import Sidebar from "../Sidebar"
import BottomNav from "../BottomNav"
import CommandPalette from "../CommandPalette"
import TeamWelcomeModal from "../../TeamWelcomeModal"
import DialogoDosPasos from "../../seguridad/DialogoDosPasos"

export default function Layout() {
  return (
    <div className="min-h-screen bg-background">
      {/* Desktop sidebar */}
      <aside className="fixed inset-y-0 left-0 z-30 hidden w-64 border-r border-line bg-card md:block">
        <Sidebar />
      </aside>

      {/* Main column with header + content */}
      <div className="flex min-h-screen flex-col md:pl-64">
        <Header />

        <main className="flex-1 pb-28 md:pb-8">
          <Outlet />
        </main>
      </div>

      {/* Mobile bottom nav */}
      <BottomNav />

      <CommandPalette />

      <TeamWelcomeModal />

      {/* Se abre cuando la API frena una petición por la verificación en dos pasos */}
      <DialogoDosPasos />
    </div>
  )
}
